export default __webpack_public_path__ + "static/media/@marimassariol.3338fdf9.jpg";